import React from "react";

const columns = [
  {
    title: "Name",
    dataIndex: "user_fullname",
    key: "user_fullname"
  },
  {
    title: "Entreprise",
    dataIndex: "user_portail2_nomEntreprise",
    key: "user_portail2_nomEntreprise"
  },
  {
    title: "Montant validé",
    dataIndex: "total_validated",
    key: "total_validated",
    render: value => {
      return <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>;
    }
  },
  {
    title: "Montant total des avances à déduire",
    dataIndex: "deduction",
    key: "deduction",
    render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
  },
  {
    title: "Montant total autres déductions (contraventions, kilomètres perso, frais postaux)",
    dataIndex: "total",
    key: "otherDeduction",
    render: (_, record) => {
      const { total_fine, total_km, total_postal } = record;
      const totalOtherDeduction =
        Number.parseFloat(total_fine) || 0 + Number.parseFloat(total_km) || 0 + Number.parseFloat(total_postal) || 0;
      return (
        <div className="py-6">{totalOtherDeduction ? Number.parseFloat(totalOtherDeduction).toFixed(2) : 0} €</div>
      );
    }
  },
  {
    title: "Montant total à rembourser",
    dataIndex: "total",
    key: "total",
    render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
  },
  {
    title: "Statut",
    dataIndex: "status",
    key: "status",
    render: status => {
      // const getStatusStyle = statusId => {
      //   if (statusId === 1) return "text-gray-400";
      //   else if (statusId === 2) return "text-green-400";
      //   return "text-red-500";
      // };

      return <div className="font-bold">{status.label}</div>;
    }
  }
];

export default columns;



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersCompany/TransfersCompany.utils.js